import TextCell from 'components/TextCell';

type CreatedBy = {
  name?: string | null;
};

interface CellProps {
  rowData: {
    createdBy?: CreatedBy | null;
  };
}

export default function CreatedByCell({ rowData: { createdBy } }: CellProps) {
  return <TextCell text={createdBy?.name ?? undefined} />;
}
